export const MAP_DEFAULT_CENTER: google.maps.LatLngLiteral = {
    lat: 49.4,
    lng: 17.3,
}

export const DEFAULT_ZOOM = 7
export const MAX_ZOOM = 18

// Map ID is required by AdvancedMarkerElement; set up a Map Style with this ID
// in Google Cloud Console (Maps > Map Styles) to customise the look.
export const MAP_ID = 'topgain-map'
